<div class="ng-bootstrap-card p-3">
  <div class="d-flex flex-row m-0">
    <div class="pe-3">
      <fa-icon [icon]="faIcon" [attr.aria-label]="iconTitle"></fa-icon>
    </div>
    <div class="addable-device-details">
      <h4>{{ heading }}</h4>
      <p>{{ description }}</p>

      @if (adding) {
        <div>
          <h3>{{ 'content.adding-device' | translate }}</h3>
          <ng-content></ng-content>
        </div>
      }

      <div class="d-flex flex-row justify-content-end ms-0 me-0 mt-2 inline-gap-10">
        @if (!adding) {
          <button class="tu-button tu-shadow primary" (click)="onAdd($event)">{{ 'content.add' | translate }}</button>
        }
      </div>
    </div>
  </div>
</div>
